import config from '@config/config';
import { Layer } from '@src/meta/types/wms/Layer';
import { ByocCollectionsCache } from '@src/meta/types/byoc';

import {
  AWS_US_WEST_2_COLLECTIONS,
  getServiceEndpoint as getServiceEndpointGeneric,
} from '@src/lib/skin/producerCollections';
import { DatasetId } from '@src/meta/types/wms/Dataset';
import { AWS_EU_CENTRAL_1_COLLECTIONS, CREODIAS_COLLECTIONS } from '@src/lib/skin/const';

export const getServiceEndpoint = (
  layers: Layer[] | undefined,
  byocCollectionsCache: ByocCollectionsCache,
) =>
  getServiceEndpointGeneric(
    layers,
    undefined,
    config.wmsConfigurationServiceBasePath,
    byocCollectionsCache,
  );

export function handleStandardCollections(layerDataset: DatasetId) {
  if (AWS_EU_CENTRAL_1_COLLECTIONS.has(layerDataset)) {
    return config.wmsConfigurationServiceBasePath;
  }
  if (AWS_US_WEST_2_COLLECTIONS.has(layerDataset)) {
    return config.usWestWmsServiceBasePath;
  }
  if (CREODIAS_COLLECTIONS.has(layerDataset)) {
    return config.byocCreodiasServiceBasePath;
  }
}
